const ThankYou = () => {
  return (
    <section className="pt-24 pb-16">
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-4xl font-bold text-foreground mb-6">Thank you!</h1>
        <p className="text-lg text-muted-foreground mb-8">
          We've received your submission. Our team will follow up with you shortly.
        </p>
        <a
          href="/"
          className="inline-block bg-accent hover:bg-accent/80 text-accent-foreground px-6 py-3 rounded-lg transition-colors"
        >
          Back to Home
        </a>
      </div>
    </section>
  );
};

export default ThankYou;